export default __webpack_public_path__ + "navigation-examples-route-deserialize-thumbnail-v1-960-d23d401fc39118c4f6dd686ac994c880.webp";